import { render, staticRenderFns } from "./symptom.vue?vue&type=template&id=1d88364a&scoped=true"
import script from "./symptom.vue?vue&type=script&lang=js"
export * from "./symptom.vue?vue&type=script&lang=js"
import style0 from "./symptom.vue?vue&type=style&index=0&id=1d88364a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d88364a",
  null
  
)

export default component.exports